<template>
  <div class="page-wrapper">
    <div class="page-inner">
      <div class="page-content-wrapper">
        <pHeader />
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive" />
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive" />
      </div>
    </div>
  </div>
</template>
<script>
import appsettings from "../../utils/appsettings";
import pHeader from "../../components/PortalHeader";
import { fetch } from "../../utils/request";

export default {
  components: {
    pHeader
  },
  data () {
    return {
      appsettings: appsettings,
    };
  },
  created () {

  },
  mounted () {

  },
  computed: {
  },
  methods: {

  }
};
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/portalHome/portalHome.vue